/**
 * The front page's plain-DOM helpers (B3.1, B3.2, B3.10): an element `index.html` must hold,
 * and a new element or button with its id, class and words. No Pixi; the ids and classes the
 * callers give are what the e2e tests read.
 */

/** The element of `index.html` with this id, of this kind; a page without it is a broken build. */
export function byId<T extends HTMLElement>(id: string, kind: { new (): T }): T {
  const found = document.getElementById(id);
  if (!(found instanceof kind)) {
    throw new Error(`index.html is missing #${id}`);
  }
  return found;
}

export interface MadeProps {
  readonly id?: string;
  readonly className?: string;
  readonly text?: string;
}

/** A new element with the id, class and words given (each left unset when empty). */
export function make<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: MadeProps = {},
): HTMLElementTagNameMap[K] {
  const made = document.createElement(tag);
  if (props.id) {
    made.id = props.id;
  }
  if (props.className) {
    made.className = props.className;
  }
  if (props.text) {
    made.textContent = props.text;
  }
  return made;
}

/** A new button that submits no form. */
export function makeButton(props: MadeProps): HTMLButtonElement {
  const button = make("button", props);
  button.type = "button";
  return button;
}
